import { VehiclePayload, VehicleResponse } from "api/types";
import { getAvailableVehicleData } from "api/vehicles/vehicle";
import SectionGridFilterCard from "containers/AvailableCarsPage/SectionGridFilterCard";
import { formatDateTime, useData } from "data/data-provider";
import { CarListingModal } from "models/vehicleModal";
import React, { FC, useEffect, useState } from "react";
import FleetCard from "./FleetCard";
import { tripModificationRequest } from "api/booking/booking";
import toast from "react-hot-toast";

interface VehicleSwapProp {
  bookingDetails: any;
}
const VehicleSwap: FC<VehicleSwapProp> = ({ bookingDetails }) => {
  const [loadingAvailableFleet, setLoadingAvailableFleet] =
    useState<boolean>(false);
  const [availableFleet, setAvailableFleet] = useState<VehicleResponse[]>([]);
  const [filteredFleet, setFilteredFleet] = useState<CarListingModal[] | []>(
    availableFleet ?? []
  );
  const {
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    endPeriod,
    pickupLocation,
    dropOffLocation,
    selectedCar,
    setSelectedCar,
  } = useData();

  useEffect(() => {
    callAvailableFleetAPI();
  }, []);

  const callAvailableFleetAPI = async () => {
    setLoadingAvailableFleet(true);

    if (!startDate || !endDate) {
      console.error("Start date or end date is not set");
      setLoadingAvailableFleet(false);
      return;
    }

    const vehiclePayload: VehiclePayload = {
      available: true,
      start_time: formatDateTime(
        startDate,
        startHours,
        startMinutes,
        startPeriod
      ),
      end_time: formatDateTime(endDate, endHours, endMinutes, endPeriod),
      pickup_location: pickupLocation?.id,
      dropoff_location: dropOffLocation?.id,
    };

  
    const transformCarListingToVehicleResponse = (
      carListing: CarListingModal[]
    ): VehicleResponse[] => {
      return carListing.map((car) => ({
        ...car,
      }));
    };

    try {
      const result = await getAvailableVehicleData(vehiclePayload);

      setLoadingAvailableFleet(false);

      if (result.error) {
        setLoadingAvailableFleet(false);
      } else if (result.data) {
        const activeVehicles = (result.data as CarListingModal[]).filter(
          (vehicle) => vehicle.active
        );
        setAvailableFleet(transformCarListingToVehicleResponse(activeVehicles));
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
      setLoadingAvailableFleet(false);
    } finally {
      setLoadingAvailableFleet(false);
    }
  };

  const TripModificationRequest = async (id:number) => {
    const payload = {
      booking: bookingDetails?.id,
      fleet:id
    };
    try {
      const result = await tripModificationRequest(payload);
      console.log(result);
      if (!result.error) {
        toast.success("Your booking modification request has been sent.");
      } else {
        toast.error(result.error);
      }
    } catch (err) {
      toast.error("An error occurred while processing your request.");
    }
  };

  const renderCard = (car: any) => {
    return <FleetCard key={car.id} data={car} simpleImg={true}  clickFunction={TripModificationRequest} />;
  };
  return (
    <div>
      <div className="nc-SectionGridFeaturePlaces relative  mt-12">
        <div
          className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4`}
        >
          {availableFleet?.map(
            (car: any) => car?.active === true && renderCard(car)
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleSwap;
